import SalesTerms from '../../../../../pages/vip/features/sales-terms-short-description/sales-terms-short-description.desktop';

export default SalesTerms;
